module.exports = __webpack_public_path__ + "img/truemoney.584f8d93.png";